var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconSe = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "currentColor"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M6 1a5 5 0 0 0-5 5v8.345a5 5 0 0 0 5 5h4.365a1 1 0 1 0 0-2H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h8.068a3 3 0 0 1 3 3v4.144a1 1 0 0 0 2 0V6a5 5 0 0 0-5-5zm.938 4.232a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m2 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M9.758 12.605c0-1.366 1.145-2.514 2.607-2.514s2.608 1.148 2.608 2.514-1.145 2.514-2.608 2.514c-1.462 0-2.607-1.148-2.607-2.514m2.607-4.214c-2.356 0-4.307 1.865-4.307 4.214s1.95 4.214 4.307 4.214c.812 0 1.575-.221 2.228-.607l1.095 1.212 1.483 1.641a.85.85 0 0 0 1.261-1.14l-1.483-1.641-1.092-1.21a4.13 4.13 0 0 0 .816-2.469c0-2.35-1.95-4.214-4.308-4.214",
  clipRule: "evenodd"
})));
export default SvgIconSe;